import { render, staticRenderFns } from "./ScrollContainer.vue?vue&type=template&id=0867e75a&scoped=true"
import script from "./ScrollContainer.vue?vue&type=script&lang=js"
export * from "./ScrollContainer.vue?vue&type=script&lang=js"
import style0 from "./ScrollContainer.vue?vue&type=style&index=0&id=0867e75a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867e75a",
  null
  
)

export default component.exports